<script setup>
/**
 * Dining Profile → Notes — a destination reached from the Profile icon grid.
 *
 * Founder review, 2026-09-18: Notes no longer sit permanently under the Profile
 * card. They behave like every other Profile destination (Membership, Messages,
 * Partners): a tile you tap, a page you leave with Back. The surface itself is
 * unchanged — DiningProfileNotes reads and writes the member's GENERAL entries
 * (ProfileEntry with no restaurant) through /profile/general-notes and
 * /profile/entries. Restaurant-specific notes stay under Favorites → Notes.
 */
import { storeToRefs } from 'pinia'
import { useUsersStore } from '@/stores'
import DiningProfileNotes from '@core/components/DiningProfileNotes.vue'

const usersStore = useUsersStore()
const { myUser } = storeToRefs(usersStore)

// Back goes to the member's own Profile — the screen the Notes tile lives on.
const backTo = computed(() => (myUser.value?.profileId ? `/m/${myUser.value.profileId}` : '/m/'))
</script>

<template>
  <div class="notes-page">
    <div class="max-content-width notes-page__nav">
      <RouterLink
        :to="backTo"
        class="notes-page__back d-flex align-center cursor-pointer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="m15 18-6-6 6-6" />
        </svg>
        <span class="ml-1">Back</span>
      </RouterLink>
    </div>

    <div class="max-content-width">
      <DiningProfileNotes />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.notes-page {
  width: 100%;
  margin: 0 auto;
  padding: 0 0.4rem;
}

.notes-page__nav {
  padding: 16px 16px 0;
}

.notes-page__back {
  font-size: 14px;
  color: var(--ds-text-secondary, rgba(0, 0, 0, 0.6));
  text-decoration: none;

  &:hover {
    color: var(--ds-text-primary, rgba(0, 0, 0, 0.87));
  }
}
</style>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: AclDemo
  allowLoggedInOnly: true
</route>
